// Função para padronizar o preenchimento com zero
const padZero = (num) => String(num).padStart(2, '0')

// Função para formatar data/hora no formato brasileiro
const dateTimeSqlToDateTimeBR = (value) => {
  if (!value) return value

  const date = new Date(value)
  return date.toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })
}

// Função para converter timestamp para data no formato brasileiro
const convertTimestampToBrazilianDate = (timestamp, withTime = true) => {
  if (!timestamp) return timestamp

  const date = new Date(timestamp * 1000) // Convertendo de segundos para milissegundos
  const day = padZero(date.getDate())
  const month = padZero(date.getMonth() + 1) // Meses começam do 0
  const year = date.getFullYear()
  const hours = padZero(date.getHours())
  const minutes = padZero(date.getMinutes())
  const seconds = padZero(date.getSeconds())

  if (!withTime) return `${day}/${month}/${year}`
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}

// Função para converter segundos em horas
const convertSecondsToHours = (totalSeconds) => {
  if (totalSeconds === undefined || totalSeconds === null) return '00:00:00'

  const isNegative = totalSeconds < 0
  const absSeconds = Math.abs(totalSeconds)

  const hours = Math.floor(absSeconds / 3600)
  const minutes = Math.floor((absSeconds % 3600) / 60)
  const seconds = absSeconds % 60

  // Formatação de horas, minutos e segundos
  const formattedHours = hours < 10 ? `0${hours}` : hours
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds

  // Retorna a hora no formato hh:mm:ss
  const timeString = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  return isNegative ? `-${timeString}` : timeString
}

export {
  dateTimeSqlToDateTimeBR,
  convertTimestampToBrazilianDate,
  convertSecondsToHours,
}
